import http from '../utils/http';

export default class LoginService {
  static getBlankForm() {
    return {
      city: null,
      username: null,
      password: null,
      captcha: null,
    };
  }

  static getChangePasswordBlankForm() {
    return {
      senha: '',
      novaSenha: '',
      repitaNovaSenha: '',
    };
  }

  static formValidation({ captcha }, captchaRef) {
    if (!captchaRef.validate(captcha)) {
      throw new Error('Erro ao preencher o captcha');
    }
  }

  static async firstAccess(form) {
    await http.post('/usuarios/primeiro-acesso', form);
  }

  static async authenticate(credentials) {
    const form = new FormData();
    form.append('grant_type', 'password');
    form.append('username', credentials.username);
    form.append('password', credentials.password);

    const { data } = await http.post('/oauth/token', form);
    return data;
  }

  static async changePassword(form) {
    await http.post('/usuarios/trocar-senha', form);
  }
}
